/**
 * We utilize the fact that double byte characters are represented by two UTF-16 code units.
 * charCodeAt will return only the first code unit from the double byte character.
 * And codePointAt will return the entire code point.
 * As a result, if the first code unit is not equal to the code point,
 * it means that the first character is a double byte character.
 * See https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/charCodeAt
 */
const startsWithDoubleByte = (str: string): boolean =>
  str.charCodeAt(0) !== str.codePointAt(0);

const getEdgeElements = (arr: string[]): string[] => {
  if (arr.length > 2) {
    return [arr[0] as string, arr[arr.length - 1] as string];
  }

  return arr;
};

export const getInitials = (str: string): string =>
  getEdgeElements(str.split(' '))
    .map((n) =>
      startsWithDoubleByte(n)
        ? (n.charAt(0) + n.charAt(1)).toUpperCase()
        : n.charAt(0).toUpperCase(),
    )
    .join('');
